import {GetSeferData} from "SeferPetach/GetData";

export async function getTeachingStructureList(list_type) {
    let ipoint = "";
    switch (list_type) { 
        case 1:
            ipoint = "tssf1";
            break;
        case 2:
            ipoint = "tsaf1";
            break;
        case 3:
            ipoint = "tspf1";
            break;
        case 4:
            ipoint = "tscf1";
            break;
        case 5:
            ipoint = "tsaaf1";
            break;
        default: 
            break;
    }
    var args = {};
    var payload = await GetSeferData(ipoint, args);
    return (payload);
}

export async function getSchoolByID(item_id){
    var args = {
        'SCHOOL_ID': item_id
    };
    var payload = await GetSeferData("tssf7", args);
    return (payload);
}
export async function getAreaByID(item_id){
    var args = {
        'AREA_ID': item_id
    };
    var payload = await GetSeferData("tsaf7", args);
    return (payload);
}
export async function getProgramByID(item_id){
    var args = {
        'PROGRAM_ID': item_id
    };
    var payload = await GetSeferData("tspf7", args);
    return (payload);
}
export async function getCustomerByID(item_id){
    var args = {
        'CLIENT_ID': item_id
    };
    var payload = await GetSeferData("tscf7", args);
    return (payload);
}
export async function getAcademicAreaByID(item_id){
    var args = {
        'ACADEMIC_AREA_ID': item_id
    };
    var payload = await GetSeferData("tsaaf7", args);
    return (payload);
}

export async function updateSchool(obj) {
    var args = obj;
    var payload = await GetSeferData("tssf2", args);
    return (payload);
}
export async function deleteSchool(school_id){
    var args = {
        'SCHOOL_ID': school_id
    };
    var payload = await GetSeferData("tssf3", args);
    return (payload);
}
export async function updateArea(obj) {
    var args = obj;
    var payload = await GetSeferData("tsaf2", args);
    return (payload);
}
export async function deleteArea(area_id){
    var args = {
        'AREA_ID': area_id
    };
    var payload = await GetSeferData("tsaf3", args);
    return (payload);
}
export async function updateProgram(obj) {
    var args = obj;
    var payload = await GetSeferData("tspf2", args);
    return (payload);
}
export async function deleteProgram(program_id){
    var args = {
        'PROGRAM_ID': program_id
    };
    var payload = await GetSeferData("tspf3", args);
    return (payload);
}
export async function updateCustomer(obj) {
    var args = obj;
    var payload = await GetSeferData("tscf2", args);
    return (payload);
}
export async function deleteCustomer(client_id){
    var args = {
        'CLIENT_ID': client_id
    };
    var payload = await GetSeferData("tscf3", args);
    return (payload);
}
export async function updateAcademicArea(obj) {
    var args = obj;
    var payload = await GetSeferData("tsaaf2", args);
    return (payload);
}
export async function deleteAcademicArea(academic_area_id){
    var args = {
        'ACADEMIC_AREA_ID': academic_area_id
    };
    var payload = await GetSeferData("tsaaf3", args);
    return (payload);
}